export default (...args) =>
  args
    .reduce((classNames, arg) => {
      if (typeof arg === 'undefined') {
        return classNames;
      }

      if (typeof arg === 'string') {
        return [...classNames, arg];
      }

      if (typeof arg === 'object') {
        return [
          ...classNames,
          ...Object.keys(arg)
            .map((className) => {
              const isEnabled = Boolean(arg[className]);
              return isEnabled ? className : null;
            })
            .filter((className) => className),
        ];
      }

      throw new Error('Unsupported argument for classnames utility.');
    }, [])
    .join(' ');
